(function () {
  // Gallery: thumbnail click swaps main image; click main image toggles zoom class
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.full || t.src;
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
    if (main) main.addEventListener('click', function () { main.classList.toggle('zoomed'); });
  });

  // Color/variant swatches: selecting a swatch updates the hidden variant select
  document.querySelectorAll('[data-swatches]').forEach(function (group) {
    group.querySelectorAll('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('[data-swatch]').forEach(function (x) { x.classList.remove('on'); });
        sw.classList.add('on');
        var select = document.querySelector(group.dataset.controls);
        if (select) {
          select.value = sw.dataset.variantId;
          select.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // Variant select -> swap main gallery image if that variant has a featured image
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var img = opt.getAttribute('data-image');
      var main = document.querySelector('[data-gallery-main] img');
      if (img && main) main.src = img;
    });
  });

  // Quantity selector
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-pqty-minus]');
    var plus = e.target.closest('[data-pqty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-pqty]');
    var input = wrap.querySelector('input[name="quantity"]');
    var v = parseInt(input.value || 1, 10);
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  // Quick view: fetch a product section and show in a modal
  var qvScrim = document.querySelector('[data-quickview-scrim]');
  var qvPanel = document.querySelector('[data-quickview-panel]');
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger && qvPanel) {
      e.preventDefault();
      qvPanel.querySelector('[data-quickview-body]').innerHTML = '<p class="muted-sm" style="padding:40px">Loading…</p>';
      window.themeTrapOpen(qvScrim, qvPanel);
      fetch('/products/' + trigger.dataset.handle + '?section_id=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) { qvPanel.querySelector('[data-quickview-body]').innerHTML = html; });
    }
    if ((e.target.closest('[data-quickview-close]') || e.target === qvScrim) && qvPanel) window.themeTrapClose(qvScrim, qvPanel);
  });

  // Collection filters: progressive enhancement — submit is native by default,
  // but we intercept to swap just the product grid via section rendering (no full page reload).
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var grid = document.querySelector('[data-collection-grid]');
    function applyFilters(url, push) {
      grid.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=main-collection')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          var newFilters = doc.querySelector('[data-filter-form]');
          if (newGrid) grid.innerHTML = newGrid.innerHTML;
          if (newFilters) filterForm.innerHTML = newFilters.innerHTML;
          if (push) history.pushState({}, '', url);
          grid.classList.remove('is-loading');
        }).catch(function () { window.location.href = url; });
    }
    filterForm.addEventListener('change', function (e) {
      if (!e.target.matches('input,select')) return;
      e.preventDefault();
      var params = new URLSearchParams(new FormData(filterForm));
      applyFilters(window.location.pathname + '?' + params.toString(), true);
    });
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); });
    window.addEventListener('popstate', function () { applyFilters(window.location.href, false); });
  }

  // Countdown timer
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.style.display = 'none'; return; }
      var d = Math.floor(diff / 86400000), h = Math.floor(diff % 86400000 / 3600000), m = Math.floor(diff % 3600000 / 60000), s = Math.floor(diff % 60000 / 1000);
      el.querySelector('[data-cd-d]').textContent = String(d).padStart(2, '0');
      el.querySelector('[data-cd-h]').textContent = String(h).padStart(2, '0');
      el.querySelector('[data-cd-m]').textContent = String(m).padStart(2, '0');
      el.querySelector('[data-cd-s]').textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  // Exit-intent / delayed promo popup, with a "don't show again for N days" cookie via localStorage
  var popup = document.querySelector('[data-popup-card]');
  if (popup) {
    var scrim = document.querySelector('[data-popup-scrim]');
    var KEY = 'pl_popup_dismissed_at';
    var freqDays = parseInt(popup.dataset.popupFrequencyDays || 7, 10);
    function dismissedRecently() {
      var t = localStorage.getItem(KEY);
      if (!t) return false;
      return (Date.now() - parseInt(t, 10)) < freqDays * 86400000;
    }
    function open() {
      if (dismissedRecently()) return;
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('on');
      scrim.classList.add('on');
    }
    function close() {
      popup.setAttribute('aria-hidden', 'true');
      popup.classList.remove('on');
      scrim.classList.remove('on');
      localStorage.setItem(KEY, Date.now().toString());
    }
    popup.addEventListener('theme:popup-close', close);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === scrim) close();
    });
    if (popup.dataset.popupMode === 'exit') {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY < 10) open();
      });
    } else {
      setTimeout(open, (parseInt(popup.dataset.popupDelay || 8, 10)) * 1000);
    }
  }
})();

(function () {
  document.querySelectorAll('[data-recommendations-section]').forEach(function (mount) {
    if (!mount.dataset.url) return;
    fetch(mount.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.querySelector('[data-recommendations-section]') || doc.body.firstElementChild;
      mount.innerHTML = section ? section.innerHTML : html;
      mount.removeAttribute('data-recommendations-section');
    }).catch(function () {});
  });
})();
